varying float vCarrierDistance;
uniform vec3 uCarrierPosition;
varying vec3 vPositionW;

void main() {
  vPositionW = (modelMatrix * vec4(position, 1.0)).xyz;
  vCarrierDistance = distance(vPositionW, uCarrierPosition);
}